import React from 'react';
import { useTranslation } from 'react-i18next';
import { useApp } from '../../context/AppContext';
import { HiCheckCircle } from 'react-icons/hi2';

const DocumentItem = ({ documentId, labelKey }) => {
  const { t } = useTranslation();
  const { getDocument, updateDocument } = useApp();
  
  const doc = getDocument(documentId) || { checked: false };

  const toggleCheck = () => {
    updateDocument(documentId, { checked: !doc.checked });
  };

  return (
    <div className="p-4">
      <div className="flex items-center gap-3">
        {/* Checkbox */}
        <button 
          onClick={toggleCheck}
          className="flex-shrink-0"
        >
          {doc.checked ? (
            <HiCheckCircle className="h-6 w-6 text-teal-600 dark:text-teal-400" />
          ) : (
            <div className="h-6 w-6 border-2 border-gray-400 dark:border-gray-500 rounded-full hover:border-teal-500 dark:hover:border-teal-400 transition-colors" />
          )}
        </button>

        {/* Label */}
        <button 
          onClick={toggleCheck}
          className="flex-1 text-start"
        >
          <p className={`text-base transition-all ${
            doc.checked 
              ? 'text-gray-500 dark:text-gray-500 line-through' 
              : 'text-gray-900 dark:text-white font-medium'
          }`}>
            {t(labelKey)}
          </p>
        </button>
      </div>
    </div>
  );
};

export default DocumentItem;
